import {Link} from 'react-router-dom';
import PropTypes from 'prop-types';
import {useMatch} from '../utils/router';

const NavLink = ({href, active, activeOnlyWhenExact, react_route, className, children, onRefresh, onClick, target, ...props}) => {
    const matches = useMatch(href, {active, exact: activeOnlyWhenExact});
    if (!target || typeof target !== 'string') {
        // Be more permissive than Link/a and silently accept boolean values to mean no target.
        target = undefined;
    }
    return (
        react_route
            ? (
                <Link
                    className={matches ? `${className} active` : className}
                    to={href}
                    target={target}
                    onClick={(event) => {
                        if (typeof onClick === 'function') {
                            onClick();
                        }
                        if (matches && typeof onRefresh === 'function') {
                            event.preventDefault();
                            onRefresh();
                        }
                    }}
                    {...props}
                >
                    {children}
                </Link>
            )
            : <a className={matches ? `${className} active` : className} target={target} href={href} {...props}>{children}</a>
    );
};

NavLink.propTypes = {
    href: PropTypes.string.isRequired,
    react_route: PropTypes.bool,
    activeOnlyWhenExact: PropTypes.bool,
    onClick: PropTypes.func,
    target: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
};

export default NavLink;
